<template>
	<div class="message">
		<van-nav-bar class="custom-nav-bar" :title="$t('assets.page_title')">
			<template #left>
				<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
					<div class="nav-bar__back">
						<span class="tn-icon-left-arrow"></span>
					</div>
				</div>
			</template>
		</van-nav-bar>
		<div class="page-content">
			<div class="balance-card">
				<div class="balance-header">
					<div class="balance-title">{{ $t('assets.account_balance') }}</div>
				</div>
				<div class="balance-amount">
					<div class="amount-value">€{{ displayBalance }}</div>
				</div>
			</div>

			<div class="action-section">
				<div class="action-item" @click="$router.push({path:'/Recharge'});">
					<div class="action-circle recharge-circle">
						<span class="tn-icon-download action-icon-text"></span>
					</div>
					<div class="action-label">
						{{ $t('recharge.page_title') }}
					</div>
				</div>
				<div class="action-item" @click="$router.push({path:'/Withdraw'});">
					<div class="action-circle withdraw-circle">
						<span class="tn-icon-upload action-icon-text"></span>
					</div>
					<div class="action-label">
						{{ $t('withdraw.page_title') }}
					</div>
				</div>
			</div>

			<div class="overview-card">
				<div class="section-header">
					<div class="section-title">{{ $t('assets.financial_overview') }}</div>
				</div>
				<div class="overview-row">
					<div class="overview-item">
						<div class="overview-val">€{{ displayOrderAmount }}</div>
						<div class="overview-key">{{ $t('assets.order') }}</div>
					</div>
					<div class="overview-sep"></div>
					<div class="overview-item">
						<div class="overview-val green">€{{ displayProfitAmount }}</div>
						<div class="overview-key">{{ $t('task.status_profit') }}</div>
					</div>
					<div class="overview-sep"></div>
					<div class="overview-item">
						<div class="overview-val blue">€{{ displayRechargeAmount }}</div>
						<div class="overview-key">{{ $t('recharge.page_title') }}</div>
					</div>
					<div class="overview-sep"></div>
					<div class="overview-item">
						<div class="overview-val orange">€{{ displayWithdrawAmount }}</div>
						<div class="overview-key">{{ $t('withdraw.page_title') }}</div>
					</div>
				</div>
			</div>

			<div class="records-card">
				<div class="section-header">
					<div class="section-title">{{ $t('assets.record_center') }}</div>
				</div>
				<div class="record-row" @click="$router.push({path:'/TaskList'});">
					<div class="record-left">
						<div class="record-icon order-bg">
							<span class="tn-icon-order"></span>
						</div>
						<div class="record-name">{{ $t('task.inventory_record') }}</div>
					</div>
					<div class="tn-icon-right record-arrow"></div>
				</div>
				<div class="record-divider"></div>
				<div class="record-row" @click="$router.push({path:'/RechargeList'});">
					<div class="record-left">
						<div class="record-icon recharge-bg">
							<span class="tn-icon-download"></span>
						</div>
						<div class="record-name">{{ $t('recharge.records_title') }}</div>
					</div>
					<div class="tn-icon-right record-arrow"></div>
				</div>
				<div class="record-divider"></div>
				<div class="record-row" @click="$router.push({path:'/WithdrawList'});">
					<div class="record-left">
						<div class="record-icon withdraw-bg">
							<span class="tn-icon-upload"></span>
						</div>
						<div class="record-name">{{ $t('withdraw.records_title') }}</div>
					</div>
					<div class="tn-icon-right record-arrow"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				notice: {},
				loading: false,
				finished: false,
				userInfo: {},
				personalReport: {},
			};
		},
		computed: {
			displayBalance() {
				return this.formatAmount(this.userInfo && this.userInfo.money);
			},
			displayOrderAmount() {
				return this.formatAmount(this.personalReport && this.personalReport.play_money);
			},
			displayProfitAmount() {
				return this.formatAmount(this.personalReport && this.personalReport.win_money);
			},
			displayRechargeAmount() {
				return this.formatAmount(this.personalReport && this.personalReport.recharge);
			},
			displayWithdrawAmount() {
				return this.formatAmount(this.personalReport && this.personalReport.withdrawal);
			}
		},
		methods: {
			back() {
				return window.history.back();
			},
			formatAmount(value) {
				const amount = parseFloat(value);
				return Number.isNaN(amount) ? '0.00' : amount.toFixed(2);
			},
			getUserInfo() {
				this.$http({
					method: 'get',
					url: 'user_info'
				}).then(res => {
					if (res.code === 200) {
						this.userInfo = res.data || {};
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			getPersonalReport() {
				this.$http({
					method: 'get',
					url: 'user_get_personalreport'
				}).then(res => {
					if (res.code === 200) {
						this.personalReport = res.data || {};
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			getNoticeList() {
				this.$http({
					method: 'get',
					url: 'sys_get_notice_list'
				}).then(res => {
					console.log(res);
					this.notice = res.data
				})
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.isLoading = false;
					this.getNoticeList();
				}, 500);
			},
		},
		created() {
			this.getNoticeList();
			this.getUserInfo();
			this.getPersonalReport();
		}
	};
</script>

<style lang='less' scoped>
	.message {
		background-color: #f5f5f5;
		z-index: 1;
		height: 100vh
	}

	/* 导航栏返回按钮 */
	.custom-nav-bar {
		height: 45px;
		position: fixed;
		z-index: 999;
		display: block;
		position: relative;
		line-height: normal;
	}

	::v-deep .van-nav-bar__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 0;
		height: 45px;
		padding-top: 0px;
		background-color: rgb(255, 255, 255);
		z-index: 29090;
		box-shadow: 0px 0px 41px 0px rgba(0, 0, 0, .05);
		position: fixed;
		width: 100%;
		top: 0;
	}

	::v-deep .van-nav-bar__left {
		padding: 0;
	}

	::v-deep .van-nav-bar__title {
		color: #000 !important;
		font-size: 18px;
		font-weight: 700;
		top: 0px;
		height: 45px;
		line-height: 45px;
		width: calc(100% - 100px);
		position: absolute;
		text-align: center;
		left: 0;
		right: 0;
		bottom: 0;
		cursor: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.nav-bar__back {
		width: 31px;
		height: 31px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .05);
		border-radius: 50%;
		color: #333;
		font-size: 14px;
	}

	/* 页面内容 */
	.page-content {
		padding: 20px 10px
	}

	/* 账户余额卡片 */
	.balance-card {
		background: linear-gradient(135deg, #d4aff9, #1f77d5);
		border-radius: 10px;
		padding: 15px;
		margin-bottom: 12px;
		color: #fff;
		box-shadow: 0 2px 10px rgba(31, 119, 213, .3)
	}

	.balance-card .balance-header {
		margin-bottom: 10px
	}

	.balance-card .balance-header .balance-title {
		font-size: 14px;
		font-weight: 600
	}

	.balance-card .balance-amount {
		margin-bottom: 8px
	}

	.balance-card .balance-amount .amount-value {
		font-size: 24px;
		font-weight: 700
	}

	.balance-card .balance-footer .balance-desc {
		font-size: 12px;
		opacity: .9
	}

	.balance-card .balance-frozen {
		display: flex;
		align-items: center;
		margin-bottom: 8px
	}

	.balance-card .balance-frozen .frozen-label {
		font-size: 12px;
		opacity: .85;
		margin-right: 6px
	}

	.balance-card .balance-frozen .frozen-value {
		font-size: 13px;
		font-weight: 600;
		color: #ffe066
	}

	/* 快捷操作 */
	.action-section {
		display: flex;
		justify-content: space-around;
		background: #fff;
		border-radius: 10px;
		padding: 20px 10px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .06)
	}

	.action-section .action-item {
		display: flex;
		flex-direction: column;
		align-items: center
	}

	.action-section .action-item .action-circle {
		width: 54px;
		height: 54px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 8px
	}

	.action-section .action-item .action-circle.recharge-circle {
		background: linear-gradient(135deg, #43e97b, #38f9d7)
	}

	.action-section .action-item .action-circle.withdraw-circle {
		background: linear-gradient(135deg, #f5a623, #f76b1c)
	}

	.action-section .action-item .action-circle .action-icon-text {
		font-size: 23px;
		color: #fff
	}

	.action-section .action-item .action-label {
		font-size: 13px;
		font-weight: 600;
		color: #333
	}

	/* 资金概览 */
	.overview-card {
		background: #fff;
		border-radius: 10px;
		padding: 14px 10px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .06)
	}

	.overview-card .section-header {
		margin-bottom: 12px
	}

	.overview-card .section-header .section-title {
		font-size: 15px;
		font-weight: 700;
		color: #222
	}

	.overview-card .overview-row {
		display: flex;
		align-items: center
	}

	.overview-card .overview-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center
	}

	.overview-card .overview-item .overview-val {
		font-size: 14px;
		font-weight: 700;
		color: #333;
		margin-bottom: 4px
	}

	.overview-card .overview-item .overview-val.green {
		color: #19cf8a
	}

	.overview-card .overview-item .overview-val.blue {
		color: #1f77d5
	}

	.overview-card .overview-item .overview-val.orange {
		color: #f5a623
	}

	.overview-card .overview-item .overview-key {
		font-size: 11px;
		color: #999
	}

	.overview-card .overview-sep {
		width: 0.5px;
		height: 31px;
		background: #f0f0f0;
		flex-shrink: 0
	}

	/* 记录中心 */
	.records-card {
		background: #fff;
		border-radius: 10px;
		padding: 14px 10px;
		margin-bottom: 12px;
		box-shadow: 0 1px 6px rgba(0, 0, 0, .06)
	}

	.records-card .section-header {
		margin-bottom: 6px
	}

	.records-card .section-header .section-title {
		font-size: 15px;
		font-weight: 700;
		color: #222
	}

	.records-card .record-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 14px 0
	}

	.records-card .record-row .record-left {
		display: flex;
		align-items: center
	}

	.records-card .record-row .record-left .record-icon {
		width: 37px;
		height: 37px;
		border-radius: 9px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		font-size: 18px;
		color: #fff
	}

	.records-card .record-row .record-left .record-icon.order-bg {
		background: linear-gradient(135deg, #667eea, #764ba2)
	}

	.records-card .record-row .record-left .record-icon.recharge-bg {
		background: linear-gradient(135deg, #43e97b, #38f9d7);
		color: #1a7a50
	}

	.records-card .record-row .record-left .record-icon.withdraw-bg {
		background: linear-gradient(135deg, #f5a623, #f76b1c)
	}

	.records-card .record-row .record-left .record-name {
		font-size: 15px;
		color: #333
	}

	.records-card .record-row .record-arrow {
		font-size: 14px;
		color: #ccc
	}

	.records-card .record-divider {
		height: 0.5px;
		background: #f5f5f5
	}

	/* 底部安全边距 start*/
	.tn-tabbar-height {
		min-height: 31px;
		height: calc(31px + env(safe-area-inset-bottom) / 2);
		height: calc(31px + constant(safe-area-inset-bottom))
	}
</style>
